import { useEffect, useState } from "react";

import classNames from "../../../utils/classNames";
import { salvageDay, salvageMoney } from "../../../utils/salvageMath";

const inputClass = "w-full min-w-[5.5rem] border-gray-300 py-1 px-1.5 text-sm text-gray-900 disabled:bg-gray-100 disabled:text-gray-500";

export function SalvageMoneyCell({
  value,
  disabled,
  onCommit,
}: {
  value?: number | null;
  disabled?: boolean;
  onCommit: (value: number | null) => void;
}) {
  const shown = value == null ? "" : String(value);
  const [draft, setDraft] = useState(shown);

  useEffect(() => {
    setDraft(shown);
  }, [shown]);

  const commit = () => {
    const next = salvageMoney(draft);
    if (next === salvageMoney(value)) return;
    onCommit(next);
  };

  return (
    <div className="min-w-[5.5rem]" onClick={(e) => e.stopPropagation()}>
      <input
        type="number"
        step="0.01"
        value={draft}
        disabled={disabled}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") (e.target as HTMLInputElement).blur();
          if (e.key === "Escape") setDraft(shown);
        }}
        className={inputClass}
      />
    </div>
  );
}

export function SalvageDateCell({
  value,
  onCommit,
}: {
  value?: string | null;
  onCommit: (value: string | null) => void;
}) {
  const shown = salvageDay(value) ?? "";
  const [draft, setDraft] = useState(shown);

  useEffect(() => {
    setDraft(shown);
  }, [shown]);

  const commit = () => {
    const next = salvageDay(draft);
    if (next === shown || (next == null && shown === "")) return;
    onCommit(next);
  };

  return (
    <div className="min-w-[8.5rem]" onClick={(e) => e.stopPropagation()}>
      <input
        type="date"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") (e.target as HTMLInputElement).blur();
          if (e.key === "Escape") setDraft(shown);
        }}
        className={classNames(inputClass, "min-w-[8.5rem]")}
      />
    </div>
  );
}

export function SalvageCheckCell({
  checked,
  onCommit,
}: {
  checked: boolean;
  onCommit: (checked: boolean) => void;
}) {
  return (
    <div className="flex justify-center" onClick={(e) => e.stopPropagation()}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onCommit(e.target.checked)}
        className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
      />
    </div>
  );
}
